import { render, staticRenderFns } from "./b.vue?vue&type=template&id=36519c6c&scoped=true"
import script from "./b.vue?vue&type=script&lang=js"
export * from "./b.vue?vue&type=script&lang=js"
import style0 from "./b.vue?vue&type=style&index=0&id=36519c6c&prod&lang=scss"
import style1 from "./b.vue?vue&type=style&index=1&id=36519c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36519c6c",
  null
  
)

export default component.exports